module.exports = __webpack_public_path__ + "img/H-45-ER-1000-GA.68ccd972.png";